import { action, computed, observable } from 'mobx'
import { ModalViewModel } from '@/infra/ModalViewModel'
import type { CouponSelectionViewModel } from '@/features/jobs/drafting/CouponSelectionViewModel'

/**
 * The coupon picker dialog, shared by every draft's coupon selection.
 */
export class CouponModalViewModel {
  readonly modal = new ModalViewModel({
    onClose: () => this.selectionVm?.addCoupon.reset(),
  })

  /**
   * The coupon selection that the dialog picks for.
   */
  @observable accessor selectionVm: CouponSelectionViewModel | null = null

  /**
   * Whether a coupon is being added or selected.
   */
  @computed
  get isPending() {
    return Boolean(
      this.selectionVm?.select.pending || this.selectionVm?.addCoupon.pending,
    )
  }

  /**
   * Shows the dialog for the coupon selection.
   */
  @action.bound
  show(selectionVm: CouponSelectionViewModel) {
    this.selectionVm = selectionVm
    this.modal.show()
  }
}
